/**
 * Text constants for Career Plan PDF
 * All hardcoded strings used in the Career Plan PDF are defined here
 */

export const careerPlanPDFTexts = {
  // Header
  header: {
    logo: "HATS & LADDERS",
    studentIdLabel: "Student ID:",
    sectionLabel: "My Career Plan",
  },

  // Section titles
  sections: {
    pathwayPossibility: "PATHWAY POSSIBILITY",
    pathwayPossibilitySubtitle:
      "Pathways are career areas that can be supported through programs of study beginning in high school.",
    selectedHat: "SELECTED HAT",
    selectedHatSubtitle: "Hats are specific jobs or careers within a Pathway.",
    buildingBlock: "BUILDING BLOCK",
    buildingBlockSubtitle:
      "Building Blocks are activities or experiences that you have already completed and can help inform your career choices.",
    myCoreTypes: "MY CORE TYPES",
    myCoreTypesSubtitle:
      "Compare your Core Personality Types with your selected Hat to see how well they align.",
    myWorkValues: "MY WORK VALUES",
    myWorkValuesSubtitle:
      "Compare your Work Values with your selected Hat to see how well they align.",
    educationTraining: "EDUCATION & TRAINING",
    educationTrainingSubtitle:
      "You are considering the following education and training options for your chosen career.",
    courseConnection: "COURSE CONNECTION",
    courseConnectionSubtitle:
      "These courses are typically required for your chosen career.",
    nextSteps: "NEXT STEPS",
    nextStepsSubtitle:
      "Actively plan for your career by following these next steps",
    notes: "NOTES",
  },

  // Pathway section
  pathway: {
    careerClusterLabel: "Career Cluster:",
    whyThisPathway: "WHY THIS PATHWAY?",
    defaultReflection:
      "This is placeholder text for the pathway reflection. Students would explain why they chose this pathway and what interests them about it.",
  },

  // Reflection sections
  reflection: {
    myReflection: "My Reflection",
    defaultDescription:
      '"Warning text goes here about deleting this Career Plan. Make sure users understand it can\'t be undone and that all related content will be permanently removed."',
    defaultReason:
      "Warning text goes here about deleting this Career Plan. Make sure users understand it can't be undone and that all related content will be permanently removed.",
  },

  // Core Types section
  coreTypes: {
    coreTypesAndWorkValuesOfHat:
      "CORE TYPES AND WORK VALUES OF THE SELECTED HAT",
    greatForLabel: "Great for",
    workValuesLabel: "Work Values",
    highInterest: "HIGH INTEREST",
  },

  // Mock data labels
  coreTypeNames: [
    "Doer",
    "Analyzer",
    "Creator",
    "Helper",
    "Persuader",
    "Organizer",
  ],
  workValueNames: [
    "Accomplishing Goals",
    "Being Independent",
    "Stability & Security",
    "Being Independent",
  ],

  // Next Steps
  nextSteps: {
    defaultTitle: "Work Warm-up",
    defaultDescription: "High School Clubs and Sports",
  },

  // Education options
  educationOptions: {
    defaultOption1: "4-Year College + Grad / Prof School",
    defaultOption2: "4-Year College",
  },

  // Footer
  footer: {
    documentTitle: "Career Plan",
    pagePrefix: "Page",
  },

  // Placeholder text
  placeholders: {
    defaultPathwayReflection:
      "This is placeholder text for the pathway reflection. Students would explain why they chose this pathway and what interests them about it.",
  },
};
